import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="search-select"
export default class extends Controller {
  static classes = ["field"]
  static values = {
    searchPlaceholder: { type: String, default: "검색..." },
    noResultMessage: { type: String, default: "검색 결과가 없습니다." }
  }

  connect() {
    const defaultOptions = {
      plugins: ["no_backspace_delete", "dropdown_input"],
      create: false,
      dropdownParent: 'body',
      controlClass: this.fieldClasses,
      placeholder: this.searchPlaceholderValue,
      maxOptions: 100,
      render: {
        no_results: (_data, escape) => {
          return `
            <div class="no-results">
              <span class="text-sm text-gray-500">${escape(this.noResultMessageValue)}</span>
            </div>
          `;
        }
      }
    }

    const options = { ...defaultOptions }
    this.tomSelect = new TomSelect(this.element, options)

    this.handleOptionClick = this.handleOptionClick.bind(this)
    document.addEventListener('mousedown', this.handleOptionClick, true)
  }

  handleOptionClick(event) {
    if (
      event.target.classList.contains('dropdown-input') ||
      event.target.closest('.no-results')
    ) {
      event.stopPropagation()
      event.preventDefault()
      return;
    }

    const optionElement = event.target.closest('.ts-dropdown .option')
    if (!optionElement) { return; }

    event.stopPropagation()
    event.preventDefault()

    requestAnimationFrame(() => {
      const value = optionElement.getAttribute('data-value')
      if (value && this.tomSelect) {
        this.tomSelect.setValue(value)
      }
    })

    return false
  }

  disconnect() {
    document.removeEventListener('mousedown', this.handleOptionClick, true)

    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }
}
